import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/mileage-rates/profile/loading';

export const Route = createFileRoute('/_private/settings/mileage-rates/$id')({
  pendingComponent: Loading,
});
